/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MetricNameQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("MetricNameQueryOperator");
    }

    getFixupPrototypeFunction() { return MetricNameQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<MetricNameQueryOperator>): MetricNameQueryOperator {
        let obj = Object.assign(new MetricNameQueryOperator(), model);
        MetricNameQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MetricNameQueryOperator>): MetricNameQueryOperator {
        if (!model) return null;
        return MetricNameQueryOperator.newInstance(<MetricNameQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MetricNameQueryOperator) {
        if (!obj) return;

        models.MetricNameQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MetricNameQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, MetricNameQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Metric names to include
     */
    metric_names: Array<string>;

}
